exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-mask[data-v-4fb63233]{color:#fff;position:fixed;z-index:9998;top:0;left:0;width:100%;min-height:100%;background-color:rgba(0,0,0,.5);display:flex;transition:opacity .3s ease;justify-content:center;align-items:center}.container[data-v-4fb63233]{margin:0 auto;background-color:#fff;border-radius:15px;width:40%;height:20%;padding:2% 5% 5%}.popPupText[data-v-4fb63233]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fb63233","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PopupBarSelected.vue
// module id = 751
// module chunks = 0